<div class="content" *ngIf="!loading">
  <app-header></app-header>
  <app-loader></app-loader>
  <div class="page">
    <app-login></app-login>
  </div>
</div>
<app-footer *ngIf="!loading"></app-footer>
